import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { has } from '@/features/tours/utils/dom';

export const TRAINING_TOUR_ID = 'training.intro';

registerTour({
  id: TRAINING_TOUR_ID,
  name: 'Training',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.TRAINING.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Training',
      body:
        'How-to videos for everyone on your team, organized by structure ' +
        'type and the tasks performed on it. If a video is required for you, ' +
        'you\u2019ll see a "Required" badge and we\u2019ll track when you\u2019ve watched it.',
    },
    {
      id: 'manage',
      target: '[data-tour-id="training-manage"]',
      placement: 'bottom',
      spotlightPadding: 4,
      title: 'Manage modules (admin)',
      body:
        'Client admins can jump into the management screen to upload new ' +
        'videos, edit existing ones, and assign required training to specific users.',
      skipIf: () => !has('[data-tour-id="training-manage"]'),
    },
    {
      id: 'structure-type',
      target: '[data-tour-id="training-structure-type"]',
      placement: 'top',
      spotlightPadding: 4,
      title: 'Structure types, tasks & videos',
      body:
        'Each card is a structure type (Plumbing, Electrical, Concrete, ' +
        'etc.). Inside, training videos are grouped by task. Hit "Play" — or ' +
        '"Start" if it\u2019s required of you — to launch full-screen. Required ' +
        'videos lock fast-forward until you\u2019ve watched them through.',
      skipIf: () => !has('[data-tour-id="training-structure-type"]'),
    },
  ],
});
